module.exports = __webpack_public_path__ + "assets/img/76800951d62aef8655e2e30b3b79c798.svg";